import { SharedProps } from "../../../shared/types/SharedProps";

export type ProgressBarInfoProps = SharedProps & {
    currentPercentage?: number,
    fileName?: string,
    uploadProcessStatus?: string
}

export enum UploadProcessStatus {
    Uploading = 'Wgrywanie...',
    UnpackingZipFile = 'Rozpakowywanie pliku .zip...',
    Validation = 'Walidacja struktury pliku...',
    CreatingObjects = 'Tworzenie obiektów...',
    SpacialAnalyses = 'Analizy przestrzenne...',
    MapCreation = 'Tworzenie załącznika mapy...',
    Saving = 'Zapisywanie plików...',
    Finish = 'Zakończono'
}